import { ColumnDef } from "@tanstack/react-table";
import { z, ZodObject, ZodRawShape } from "zod";
import { useTranslation } from "react-i18next";

export const PathTableColumns: ColumnDef<z.infer<ZodObject<ZodRawShape>>>[] = [
  {
    accessorKey: "identifier",
    header: "identifier",
  },
  {
    id: "warehouse.name",
    accessorKey: "warehouse.name",
    header: "warehouse",
  },
  {
    id: "warehouse.status",
    accessorKey: "warehouse.status",
    header: "status",
    cell: ({ row }) => {
      const { t } = useTranslation("common");

      if (row.original.warehouse?.status === true) {
        return t("Active");
      }

      return t("Inactive");
    },
  },
];
